function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0,
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "undraw_in_sync_xwsa"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_809",
  "data-name": "Path 809",
  d: "M39.05,27.254a11.282,11.282,0,0,0-3.608.351,6.009,6.009,0,0,0-4.1,6.78c.479,2.7,2.449,5.053,4.494,7.2s4.259,4.276,5.381,6.846a4.973,4.973,0,0,1,.252,4c-.876,1.975-3.519,3.078-6.056,3.307a51.481,51.481,0,0,1-7.63-.367,9.591,9.591,0,0,0-3.173.219,8.4,8.4,0,0,0-2.871,1.626c-3.307,2.623-5.955,6.206-5.523,9.963.484,4.265,4.8,7.636,9.519,9.445a27.335,27.335,0,0,1,4.595,1.94c3.626,2.256,4.441,6.487,4.08,10.22S32.816,96.259,33.5,99.96c.805,4.3,4.37,8.194,9.178,10.01,4.284,1.618,9.644,1.511,13.448-.772a16.273,16.273,0,0,0,4.475-4.265,34.411,34.411,0,0,0,4.45-7.706,7.492,7.492,0,0,1,2.266-3.554,7.788,7.788,0,0,1,2.7-1.094c2.919-.719,5.994-.916,8.94-1.556s5.9-1.836,7.5-3.971c2.266-3.022,1.209-6.893,1.219-10.447C87.7,68.5,93.594,61.24,95.768,53.336c.71-2.582.975-5.439-.612-7.744a11.529,11.529,0,0,0-4.8-3.564c-4.2-1.917-8.978-2.771-13.676-3.6-6.529-1.154-14.457-1.3-19.517-5.039A31.53,31.53,0,0,0,39.05,27.254Z",
  transform: "translate(-16.167 -27.243)",
  fill: "#f0b4b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_810",
  "data-name": "Path 810",
  d: "M77.405,102.073s-1.936,4.341-10.864,2.822",
  transform: "translate(-38.974 -61.13)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 0.552
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_811",
  "data-name": "Path 811",
  d: "M63.971,123.7s6.87-6.872,4.77-9.368",
  transform: "translate(-37.81 -66.683)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 0.552
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_88",
  "data-name": "Ellipse 88",
  cx: 70.26,
  cy: 18.814,
  rx: 70.26,
  ry: 18.814,
  transform: "translate(22.817 72.371)",
  fill: "#f0d9db"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_812",
  "data-name": "Path 812",
  d: "M200.418,111.148H187.561a4.285,4.285,0,0,0,.453-1.914V50.687a4.3,4.3,0,0,0-4.3-4.3H84.188a4.3,4.3,0,0,0-4.3,4.3v58.544a4.285,4.285,0,0,0,.453,1.914H67.025a1.138,1.138,0,0,0-1.138,1.138v.917a6.367,6.367,0,0,0,6.367,6.367H195.2a6.367,6.367,0,0,0,6.367-6.367v-.917a1.138,1.138,0,0,0-1.147-1.138ZM121.2,114.79l-1.1-1.253h27.365l-1.221,1.253Z",
  transform: "translate(-38.678 -35.91)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_729",
  "data-name": "Rectangle 729",
  width: 105.683,
  height: 65.635,
  rx: 6.422,
  transform: "translate(42.424 11.302)",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_730",
  "data-name": "Rectangle 730",
  width: 101.011,
  height: 53.619,
  transform: "translate(44.65 20.863)",
  fill: "#f1f1f4"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_89",
  "data-name": "Ellipse 89",
  cx: 0.89,
  cy: 0.89,
  r: 0.89,
  transform: "translate(94.265 15.306)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_813",
  "data-name": "Path 813",
  d: "M150.7,163.562l-3.475,3.56H122.744l-3.137-3.56H69.8a1.112,1.112,0,0,0-1.112,1.112v.9a6.222,6.222,0,0,0,6.23,6.222H195.068a6.222,6.222,0,0,0,6.222-6.222v-.9a1.112,1.112,0,0,0-1.112-1.112Z",
  transform: "translate(-39.946 -88.975)",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_731",
  "data-name": "Rectangle 731",
  width: 27.616,
  height: 20.812,
  transform: "translate(50.819 24.95)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_732",
  "data-name": "Rectangle 732",
  width: 9.205,
  height: 5.202,
  transform: "translate(53.521 26.752)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_733",
  "data-name": "Rectangle 733",
  width: 10.806,
  height: 1.201,
  transform: "translate(64.927 26.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_734",
  "data-name": "Rectangle 734",
  width: 7.605,
  height: 1.201,
  transform: "translate(64.927 28.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_735",
  "data-name": "Rectangle 735",
  width: 10.806,
  height: 1.201,
  transform: "translate(64.927 30.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_736",
  "data-name": "Rectangle 736",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 32.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_737",
  "data-name": "Rectangle 737",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 34.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_738",
  "data-name": "Rectangle 738",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 36.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_739",
  "data-name": "Rectangle 739",
  width: 20.412,
  height: 1.201,
  transform: "translate(53.521 38.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_740",
  "data-name": "Rectangle 740",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 40.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_741",
  "data-name": "Rectangle 741",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 42.758)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_742",
  "data-name": "Rectangle 742",
  width: 27.616,
  height: 20.812,
  transform: "translate(81.236 24.95)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_743",
  "data-name": "Rectangle 743",
  width: 9.205,
  height: 5.202,
  transform: "translate(83.936 26.752)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_744",
  "data-name": "Rectangle 744",
  width: 10.806,
  height: 1.201,
  transform: "translate(95.344 26.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_745",
  "data-name": "Rectangle 745",
  width: 7.605,
  height: 1.201,
  transform: "translate(95.344 28.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_746",
  "data-name": "Rectangle 746",
  width: 10.806,
  height: 1.201,
  transform: "translate(95.344 30.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_747",
  "data-name": "Rectangle 747",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 32.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_748",
  "data-name": "Rectangle 748",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 34.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_749",
  "data-name": "Rectangle 749",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 36.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_750",
  "data-name": "Rectangle 750",
  width: 20.412,
  height: 1.201,
  transform: "translate(83.936 38.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_751",
  "data-name": "Rectangle 751",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 40.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_752",
  "data-name": "Rectangle 752",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 42.758)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_753",
  "data-name": "Rectangle 753",
  width: 27.616,
  height: 20.812,
  transform: "translate(111.652 24.95)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_754",
  "data-name": "Rectangle 754",
  width: 9.205,
  height: 5.202,
  transform: "translate(114.353 26.752)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_755",
  "data-name": "Rectangle 755",
  width: 10.806,
  height: 1.201,
  transform: "translate(125.76 26.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_756",
  "data-name": "Rectangle 756",
  width: 7.605,
  height: 1.201,
  transform: "translate(125.76 28.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_757",
  "data-name": "Rectangle 757",
  width: 10.806,
  height: 1.201,
  transform: "translate(125.76 30.752)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_758",
  "data-name": "Rectangle 758",
  width: 22.213,
  height: 1.201,
  transform: "translate(114.353 32.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_759",
  "data-name": "Rectangle 759",
  width: 22.213,
  height: 1.201,
  transform: "translate(114.353 34.754)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_760",
  "data-name": "Rectangle 760",
  width: 22.213,
  height: 1.201,
  transform: "translate(114.353 36.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_761",
  "data-name": "Rectangle 761",
  width: 20.412,
  height: 1.201,
  transform: "translate(114.353 38.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_762",
  "data-name": "Rectangle 762",
  width: 22.213,
  height: 1.201,
  transform: "translate(114.353 40.756)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_763",
  "data-name": "Rectangle 763",
  width: 22.213,
  height: 1.201,
  transform: "translate(114.353 42.758)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_764",
  "data-name": "Rectangle 764",
  width: 27.616,
  height: 20.812,
  transform: "translate(50.819 48.358)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_765",
  "data-name": "Rectangle 765",
  width: 9.205,
  height: 5.202,
  transform: "translate(53.521 50.16)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_766",
  "data-name": "Rectangle 766",
  width: 10.806,
  height: 1.201,
  transform: "translate(64.927 50.16)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_767",
  "data-name": "Rectangle 767",
  width: 7.605,
  height: 1.201,
  transform: "translate(64.927 52.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_768",
  "data-name": "Rectangle 768",
  width: 10.806,
  height: 1.201,
  transform: "translate(64.927 54.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_769",
  "data-name": "Rectangle 769",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 56.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_770",
  "data-name": "Rectangle 770",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 58.164)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_771",
  "data-name": "Rectangle 771",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 60.164)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_772",
  "data-name": "Rectangle 772",
  width: 20.412,
  height: 1.201,
  transform: "translate(53.521 62.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_773",
  "data-name": "Rectangle 773",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 64.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_774",
  "data-name": "Rectangle 774",
  width: 22.213,
  height: 1.201,
  transform: "translate(53.521 66.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_775",
  "data-name": "Rectangle 775",
  width: 27.616,
  height: 20.812,
  transform: "translate(81.236 48.358)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_776",
  "data-name": "Rectangle 776",
  width: 9.205,
  height: 5.202,
  transform: "translate(83.936 50.16)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_777",
  "data-name": "Rectangle 777",
  width: 10.806,
  height: 1.201,
  transform: "translate(95.344 50.16)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_778",
  "data-name": "Rectangle 778",
  width: 7.605,
  height: 1.201,
  transform: "translate(95.344 52.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_779",
  "data-name": "Rectangle 779",
  width: 10.806,
  height: 1.201,
  transform: "translate(95.344 54.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_780",
  "data-name": "Rectangle 780",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 56.162)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_781",
  "data-name": "Rectangle 781",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 58.164)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_782",
  "data-name": "Rectangle 782",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 60.164)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_783",
  "data-name": "Rectangle 783",
  width: 20.412,
  height: 1.201,
  transform: "translate(83.936 62.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_784",
  "data-name": "Rectangle 784",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 64.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_785",
  "data-name": "Rectangle 785",
  width: 22.213,
  height: 1.201,
  transform: "translate(83.936 66.166)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_786",
  "data-name": "Rectangle 786",
  width: 27.616,
  height: 20.812,
  transform: "translate(111.652 48.358)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_814",
  "data-name": "Path 814",
  d: "M99.195,85.642H56.586a3.9,3.9,0,0,0-3.91,3.9v59.039a3.9,3.9,0,0,0,3.909,3.9H99.193a3.9,3.9,0,0,0,3.909-3.9V89.543a3.9,3.9,0,0,0-3.907-3.9Z",
  transform: "translate(-32.696 -53.701)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_787",
  "data-name": "Rectangle 787",
  width: 49.227,
  height: 65.437,
  rx: 5.522,
  transform: "translate(20.58 32.742)",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_788",
  "data-name": "Rectangle 788",
  width: 44.224,
  height: 53.057,
  transform: "translate(23.081 38.938)",
  fill: "#f1f1f4"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_90",
  "data-name": "Ellipse 90",
  cx: 0.6,
  cy: 0.6,
  r: 0.6,
  transform: "translate(44.393 35.156)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_91",
  "data-name": "Ellipse 91",
  cx: 1.801,
  cy: 1.801,
  r: 1.801,
  transform: "translate(43.192 93.175)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_789",
  "data-name": "Rectangle 789",
  width: 12.613,
  height: 9.507,
  transform: "translate(24.992 44.363)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_790",
  "data-name": "Rectangle 790",
  width: 4.205,
  height: 2.377,
  transform: "translate(26.227 45.187)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_791",
  "data-name": "Rectangle 791",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 45.187)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_792",
  "data-name": "Rectangle 792",
  width: 3.474,
  height: 0.548,
  transform: "translate(31.437 46.101)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_793",
  "data-name": "Rectangle 793",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 47.015)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_794",
  "data-name": "Rectangle 794",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 47.929)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_795",
  "data-name": "Rectangle 795",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 48.843)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_796",
  "data-name": "Rectangle 796",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 49.757)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_797",
  "data-name": "Rectangle 797",
  width: 9.324,
  height: 0.548,
  transform: "translate(26.227 50.671)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_798",
  "data-name": "Rectangle 798",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 51.585)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_799",
  "data-name": "Rectangle 799",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 52.499)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_800",
  "data-name": "Rectangle 800",
  width: 12.613,
  height: 9.507,
  transform: "translate(38.887 44.363)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_801",
  "data-name": "Rectangle 801",
  width: 4.205,
  height: 2.377,
  transform: "translate(40.12 45.187)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_802",
  "data-name": "Rectangle 802",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 45.187)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_803",
  "data-name": "Rectangle 803",
  width: 3.474,
  height: 0.548,
  transform: "translate(45.331 46.101)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_804",
  "data-name": "Rectangle 804",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 47.015)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_805",
  "data-name": "Rectangle 805",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 47.929)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_806",
  "data-name": "Rectangle 806",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 49.757)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_807",
  "data-name": "Rectangle 807",
  width: 9.324,
  height: 0.548,
  transform: "translate(40.12 50.671)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_808",
  "data-name": "Rectangle 808",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 51.585)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_809",
  "data-name": "Rectangle 809",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 52.499)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_810",
  "data-name": "Rectangle 810",
  width: 12.613,
  height: 9.507,
  transform: "translate(52.78 44.363)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_811",
  "data-name": "Rectangle 811",
  width: 4.205,
  height: 2.377,
  transform: "translate(54.015 45.187)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_812",
  "data-name": "Rectangle 812",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 45.187)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_813",
  "data-name": "Rectangle 813",
  width: 3.474,
  height: 0.548,
  transform: "translate(59.225 46.101)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_814",
  "data-name": "Rectangle 814",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 47.015)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_815",
  "data-name": "Rectangle 815",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 47.929)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_816",
  "data-name": "Rectangle 816",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 48.843)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_817",
  "data-name": "Rectangle 817",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 49.757)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_818",
  "data-name": "Rectangle 818",
  width: 9.324,
  height: 0.548,
  transform: "translate(54.015 50.671)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_819",
  "data-name": "Rectangle 819",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 51.585)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_820",
  "data-name": "Rectangle 820",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 52.499)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_821",
  "data-name": "Rectangle 821",
  width: 12.613,
  height: 9.507,
  transform: "translate(24.992 55.056)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_822",
  "data-name": "Rectangle 822",
  width: 4.205,
  height: 2.377,
  transform: "translate(26.227 55.88)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_823",
  "data-name": "Rectangle 823",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 55.88)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_824",
  "data-name": "Rectangle 824",
  width: 3.474,
  height: 0.548,
  transform: "translate(31.437 56.794)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_825",
  "data-name": "Rectangle 825",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 57.708)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_826",
  "data-name": "Rectangle 826",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 58.622)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_827",
  "data-name": "Rectangle 827",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 59.536)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_828",
  "data-name": "Rectangle 828",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 60.45)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_829",
  "data-name": "Rectangle 829",
  width: 9.324,
  height: 0.548,
  transform: "translate(26.227 61.364)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_830",
  "data-name": "Rectangle 830",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 62.278)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_831",
  "data-name": "Rectangle 831",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 63.192)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_832",
  "data-name": "Rectangle 832",
  width: 12.613,
  height: 9.507,
  transform: "translate(38.887 55.056)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_833",
  "data-name": "Rectangle 833",
  width: 4.205,
  height: 2.377,
  transform: "translate(40.12 55.88)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_834",
  "data-name": "Rectangle 834",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 55.88)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_835",
  "data-name": "Rectangle 835",
  width: 3.474,
  height: 0.548,
  transform: "translate(45.331 56.794)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_836",
  "data-name": "Rectangle 836",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 57.708)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_837",
  "data-name": "Rectangle 837",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 58.622)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_838",
  "data-name": "Rectangle 838",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 59.536)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_839",
  "data-name": "Rectangle 839",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 60.45)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_840",
  "data-name": "Rectangle 840",
  width: 9.324,
  height: 0.548,
  transform: "translate(40.12 61.364)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_841",
  "data-name": "Rectangle 841",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 62.278)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_842",
  "data-name": "Rectangle 842",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 63.192)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_843",
  "data-name": "Rectangle 843",
  width: 12.613,
  height: 9.507,
  transform: "translate(52.78 55.056)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_844",
  "data-name": "Rectangle 844",
  width: 4.205,
  height: 2.377,
  transform: "translate(54.015 55.88)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_845",
  "data-name": "Rectangle 845",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 55.88)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_846",
  "data-name": "Rectangle 846",
  width: 3.474,
  height: 0.548,
  transform: "translate(59.225 56.794)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_847",
  "data-name": "Rectangle 847",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 57.708)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_848",
  "data-name": "Rectangle 848",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 58.622)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_849",
  "data-name": "Rectangle 849",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 59.536)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_850",
  "data-name": "Rectangle 850",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 60.45)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_851",
  "data-name": "Rectangle 851",
  width: 9.324,
  height: 0.548,
  transform: "translate(54.015 61.364)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_852",
  "data-name": "Rectangle 852",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 62.278)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_853",
  "data-name": "Rectangle 853",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 63.192)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_854",
  "data-name": "Rectangle 854",
  width: 12.613,
  height: 9.507,
  transform: "translate(24.992 66.172)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_855",
  "data-name": "Rectangle 855",
  width: 4.205,
  height: 2.377,
  transform: "translate(26.227 66.996)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_856",
  "data-name": "Rectangle 856",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 66.996)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_857",
  "data-name": "Rectangle 857",
  width: 3.474,
  height: 0.548,
  transform: "translate(31.437 67.91)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_858",
  "data-name": "Rectangle 858",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 68.824)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_859",
  "data-name": "Rectangle 859",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 69.738)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_860",
  "data-name": "Rectangle 860",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 70.652)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_861",
  "data-name": "Rectangle 861",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 71.566)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_862",
  "data-name": "Rectangle 862",
  width: 9.324,
  height: 0.548,
  transform: "translate(26.227 72.48)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_863",
  "data-name": "Rectangle 863",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 73.394)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_864",
  "data-name": "Rectangle 864",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 74.308)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_865",
  "data-name": "Rectangle 865",
  width: 12.613,
  height: 9.507,
  transform: "translate(38.887 66.172)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_866",
  "data-name": "Rectangle 866",
  width: 4.205,
  height: 2.377,
  transform: "translate(40.12 66.996)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_867",
  "data-name": "Rectangle 867",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 66.996)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_868",
  "data-name": "Rectangle 868",
  width: 3.474,
  height: 0.548,
  transform: "translate(45.331 67.91)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_869",
  "data-name": "Rectangle 869",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 68.824)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_870",
  "data-name": "Rectangle 870",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 69.738)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_871",
  "data-name": "Rectangle 871",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 70.652)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_872",
  "data-name": "Rectangle 872",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 71.566)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_873",
  "data-name": "Rectangle 873",
  width: 9.324,
  height: 0.548,
  transform: "translate(40.12 72.48)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_874",
  "data-name": "Rectangle 874",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 73.394)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_875",
  "data-name": "Rectangle 875",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 74.308)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_876",
  "data-name": "Rectangle 876",
  width: 12.613,
  height: 9.507,
  transform: "translate(52.78 66.172)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_877",
  "data-name": "Rectangle 877",
  width: 4.205,
  height: 2.377,
  transform: "translate(54.015 66.996)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_878",
  "data-name": "Rectangle 878",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 66.996)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_879",
  "data-name": "Rectangle 879",
  width: 3.474,
  height: 0.548,
  transform: "translate(59.225 67.91)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_880",
  "data-name": "Rectangle 880",
  width: 4.936,
  height: 0.548,
  transform: "translate(59.225 68.824)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_881",
  "data-name": "Rectangle 881",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 69.738)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_882",
  "data-name": "Rectangle 882",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 70.652)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_883",
  "data-name": "Rectangle 883",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 71.566)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_884",
  "data-name": "Rectangle 884",
  width: 9.324,
  height: 0.548,
  transform: "translate(54.015 72.48)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_885",
  "data-name": "Rectangle 885",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 73.394)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_886",
  "data-name": "Rectangle 886",
  width: 10.146,
  height: 0.548,
  transform: "translate(54.015 74.308)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_887",
  "data-name": "Rectangle 887",
  width: 12.613,
  height: 9.507,
  transform: "translate(24.992 76.864)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_888",
  "data-name": "Rectangle 888",
  width: 4.205,
  height: 2.377,
  transform: "translate(26.227 77.688)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_889",
  "data-name": "Rectangle 889",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 77.689)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_890",
  "data-name": "Rectangle 890",
  width: 3.474,
  height: 0.548,
  transform: "translate(31.437 78.603)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_891",
  "data-name": "Rectangle 891",
  width: 4.936,
  height: 0.548,
  transform: "translate(31.437 79.517)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_892",
  "data-name": "Rectangle 892",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 80.431)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_893",
  "data-name": "Rectangle 893",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 81.345)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_894",
  "data-name": "Rectangle 894",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 82.259)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_895",
  "data-name": "Rectangle 895",
  width: 9.324,
  height: 0.548,
  transform: "translate(26.227 83.173)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_896",
  "data-name": "Rectangle 896",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 84.087)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_897",
  "data-name": "Rectangle 897",
  width: 10.146,
  height: 0.548,
  transform: "translate(26.227 85.001)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_898",
  "data-name": "Rectangle 898",
  width: 12.613,
  height: 9.507,
  transform: "translate(38.887 76.864)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_899",
  "data-name": "Rectangle 899",
  width: 4.205,
  height: 2.377,
  transform: "translate(40.12 77.688)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_900",
  "data-name": "Rectangle 900",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 77.689)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_901",
  "data-name": "Rectangle 901",
  width: 3.474,
  height: 0.548,
  transform: "translate(45.331 78.603)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_902",
  "data-name": "Rectangle 902",
  width: 4.936,
  height: 0.548,
  transform: "translate(45.331 79.517)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_903",
  "data-name": "Rectangle 903",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 80.431)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_904",
  "data-name": "Rectangle 904",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 81.345)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_905",
  "data-name": "Rectangle 905",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 82.259)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_906",
  "data-name": "Rectangle 906",
  width: 9.324,
  height: 0.548,
  transform: "translate(40.12 83.173)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_907",
  "data-name": "Rectangle 907",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 84.087)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_908",
  "data-name": "Rectangle 908",
  width: 10.146,
  height: 0.548,
  transform: "translate(40.12 85.001)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_909",
  "data-name": "Rectangle 909",
  width: 12.613,
  height: 9.507,
  transform: "translate(52.78 76.864)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_815",
  "data-name": "Path 815",
  d: "M58.439,122.209H36.56a2.164,2.164,0,0,0-2.168,2.159V172.28a2.164,2.164,0,0,0,2.168,2.159H58.439a2.164,2.164,0,0,0,2.168-2.159V124.37A2.164,2.164,0,0,0,58.439,122.209Z",
  transform: "translate(-24.418 -70.257)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_910",
  "data-name": "Rectangle 910",
  width: 25.815,
  height: 51.629,
  rx: 3.037,
  transform: "translate(10.174 52.354)",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_911",
  "data-name": "Rectangle 911",
  width: 22.012,
  height: 42.023,
  transform: "translate(12.075 57.156)",
  fill: "#f1f1f4"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_92",
  "data-name": "Ellipse 92",
  cx: 0.199,
  cy: 0.199,
  r: 0.199,
  transform: "translate(20.28 54.564)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_912",
  "data-name": "Rectangle 912",
  width: 4.403,
  height: 0.4,
  rx: 0.2,
  transform: "translate(21.481 54.563)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_93",
  "data-name": "Ellipse 93",
  cx: 1.401,
  cy: 1.401,
  r: 1.401,
  transform: "translate(21.581 99.78)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_913",
  "data-name": "Rectangle 913",
  width: 15.01,
  height: 11.313,
  transform: "translate(15.576 59.678)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_914",
  "data-name": "Rectangle 914",
  width: 15.01,
  height: 11.313,
  transform: "translate(15.576 72.403)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_915",
  "data-name": "Rectangle 915",
  width: 5.003,
  height: 2.829,
  transform: "translate(17.045 73.383)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_916",
  "data-name": "Rectangle 916",
  width: 5.873,
  height: 0.653,
  transform: "translate(23.244 73.383)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_917",
  "data-name": "Rectangle 917",
  width: 4.134,
  height: 0.653,
  transform: "translate(23.244 74.471)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_918",
  "data-name": "Rectangle 918",
  width: 5.873,
  height: 0.653,
  transform: "translate(23.244 75.557)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_919",
  "data-name": "Rectangle 919",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 76.645)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_920",
  "data-name": "Rectangle 920",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 77.732)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_921",
  "data-name": "Rectangle 921",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 78.82)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_922",
  "data-name": "Rectangle 922",
  width: 11.095,
  height: 0.653,
  transform: "translate(17.045 79.908)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_923",
  "data-name": "Rectangle 923",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 80.996)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_924",
  "data-name": "Rectangle 924",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 82.083)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_925",
  "data-name": "Rectangle 925",
  width: 15.01,
  height: 11.313,
  transform: "translate(15.576 85.151)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_926",
  "data-name": "Rectangle 926",
  width: 5.003,
  height: 2.829,
  transform: "translate(17.045 86.133)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_927",
  "data-name": "Rectangle 927",
  width: 5.873,
  height: 0.653,
  transform: "translate(23.244 86.134)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_928",
  "data-name": "Rectangle 928",
  width: 4.134,
  height: 0.653,
  transform: "translate(23.244 87.221)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_929",
  "data-name": "Rectangle 929",
  width: 5.873,
  height: 0.653,
  transform: "translate(23.244 88.306)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_930",
  "data-name": "Rectangle 930",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 89.394)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_931",
  "data-name": "Rectangle 931",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 90.481)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_932",
  "data-name": "Rectangle 932",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 91.569)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_933",
  "data-name": "Rectangle 933",
  width: 11.095,
  height: 0.653,
  transform: "translate(17.045 92.657)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_934",
  "data-name": "Rectangle 934",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 93.744)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_935",
  "data-name": "Rectangle 935",
  width: 12.074,
  height: 0.653,
  transform: "translate(17.045 94.831)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_816",
  "data-name": "Path 816",
  d: "M136.429,192.9s-1.744-.734-3.119-1.284-.55,1.284-.55,1.284a22.038,22.038,0,0,1,2.294.734,13.624,13.624,0,0,0,1.926.183Z",
  transform: "translate(-68.845 -101.636)",
  fill: "#f7c4a7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_817",
  "data-name": "Path 817",
  d: "M136.429,192.9s-1.744-.734-3.119-1.284-.55,1.284-.55,1.284a22.038,22.038,0,0,1,2.294.734,13.624,13.624,0,0,0,1.926.183Z",
  transform: "translate(-68.845 -101.636)",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_936",
  "data-name": "Rectangle 936",
  width: 13.736,
  height: 10.352,
  transform: "translate(57.508 82.788)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_937",
  "data-name": "Rectangle 937",
  width: 12.613,
  height: 9.507,
  transform: "translate(58.069 83.209)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_938",
  "data-name": "Rectangle 938",
  width: 4.205,
  height: 2.377,
  transform: "translate(59.303 84.033)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_939",
  "data-name": "Rectangle 939",
  width: 4.936,
  height: 0.548,
  transform: "translate(64.513 84.034)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_940",
  "data-name": "Rectangle 940",
  width: 3.474,
  height: 0.548,
  transform: "translate(64.513 84.948)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_941",
  "data-name": "Rectangle 941",
  width: 4.936,
  height: 0.548,
  transform: "translate(64.513 85.862)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_942",
  "data-name": "Rectangle 942",
  width: 10.146,
  height: 0.548,
  transform: "translate(59.303 86.776)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_943",
  "data-name": "Rectangle 943",
  width: 10.146,
  height: 0.548,
  transform: "translate(59.303 87.69)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_944",
  "data-name": "Rectangle 944",
  width: 10.146,
  height: 0.548,
  transform: "translate(59.303 88.6)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_945",
  "data-name": "Rectangle 945",
  width: 9.324,
  height: 0.548,
  transform: "translate(59.303 89.514)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_946",
  "data-name": "Rectangle 946",
  width: 10.146,
  height: 0.548,
  transform: "translate(59.303 90.429)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_947",
  "data-name": "Rectangle 947",
  width: 10.146,
  height: 0.548,
  transform: "translate(59.303 91.343)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_818",
  "data-name": "Path 818",
  d: "M118.921,216.6a.029.029,0,0,1-.009.026,2.686,2.686,0,0,0-.151.485,1.788,1.788,0,0,1,.077-.219,1.332,1.332,0,0,0,.083-.292Z",
  transform: "translate(-62.617 -112.993)",
  fill: "#dddbe2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_819",
  "data-name": "Path 819",
  d: "M103,217.634c-.048.014-.1.077-.141.168h.015c.039-.011.109-.089.193-.212A.179.179,0,0,1,103,217.634Z",
  transform: "translate(-55.417 -113.442)",
  fill: "#dddbe2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_820",
  "data-name": "Path 820",
  d: "M64.746,153.637l.686.045v-1.662l-.907-.163A2.577,2.577,0,0,1,64.746,153.637Z",
  transform: "translate(-38.062 -83.674)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_948",
  "data-name": "Rectangle 948",
  width: 15.827,
  height: 11.928,
  transform: "translate(22.572 59.523)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_949",
  "data-name": "Rectangle 949",
  width: 15.01,
  height: 11.313,
  transform: "translate(22.98 59.829)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_950",
  "data-name": "Rectangle 950",
  width: 5.003,
  height: 2.829,
  transform: "translate(24.448 60.809)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_951",
  "data-name": "Rectangle 951",
  width: 5.873,
  height: 0.653,
  transform: "translate(30.648 60.809)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_952",
  "data-name": "Rectangle 952",
  width: 4.134,
  height: 0.653,
  transform: "translate(30.648 61.897)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_953",
  "data-name": "Rectangle 953",
  width: 5.873,
  height: 0.653,
  transform: "translate(30.648 62.985)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_954",
  "data-name": "Rectangle 954",
  width: 12.074,
  height: 0.653,
  transform: "translate(24.448 64.073)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_955",
  "data-name": "Rectangle 955",
  width: 12.074,
  height: 0.653,
  transform: "translate(24.448 65.16)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_956",
  "data-name": "Rectangle 956",
  width: 12.074,
  height: 0.653,
  transform: "translate(24.448 66.246)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_957",
  "data-name": "Rectangle 957",
  width: 11.095,
  height: 0.653,
  transform: "translate(24.448 67.334)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_958",
  "data-name": "Rectangle 958",
  width: 12.074,
  height: 0.653,
  transform: "translate(24.448 68.422)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_959",
  "data-name": "Rectangle 959",
  width: 12.074,
  height: 0.653,
  transform: "translate(24.448 69.51)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_821",
  "data-name": "Path 821",
  d: "M282.974,118.65s-6.154.855-7.437.6l-3.419-3.249s-3.249,2.479,1.881,4.1l9.573,1.111Z",
  transform: "translate(-131.592 -67.439)",
  fill: "#fdc2cc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_822",
  "data-name": "Path 822",
  d: "M282.974,118.65s-6.154.855-7.437.6l-3.419-3.249s-3.249,2.479,1.881,4.1l9.573,1.111Z",
  transform: "translate(-131.592 -67.439)",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_960",
  "data-name": "Rectangle 960",
  width: 28.912,
  height: 21.788,
  transform: "translate(123.847 38.806)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_961",
  "data-name": "Rectangle 961",
  width: 27.616,
  height: 20.812,
  transform: "translate(124.495 39.294)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_962",
  "data-name": "Rectangle 962",
  width: 9.205,
  height: 5.202,
  transform: "translate(127.197 41.096)",
  fill: "#e30613",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_963",
  "data-name": "Rectangle 963",
  width: 10.806,
  height: 1.201,
  transform: "translate(138.603 41.096)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_964",
  "data-name": "Rectangle 964",
  width: 7.605,
  height: 1.201,
  transform: "translate(138.603 43.098)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_965",
  "data-name": "Rectangle 965",
  width: 10.806,
  height: 1.201,
  transform: "translate(138.603 45.098)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_966",
  "data-name": "Rectangle 966",
  width: 22.213,
  height: 1.201,
  transform: "translate(127.197 47.098)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_967",
  "data-name": "Rectangle 967",
  width: 22.213,
  height: 1.201,
  transform: "translate(127.197 49.1)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_968",
  "data-name": "Rectangle 968",
  width: 22.213,
  height: 1.201,
  transform: "translate(127.197 51.1)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_969",
  "data-name": "Rectangle 969",
  width: 20.412,
  height: 1.201,
  transform: "translate(127.197 53.102)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_970",
  "data-name": "Rectangle 970",
  width: 22.213,
  height: 1.201,
  transform: "translate(127.197 55.102)",
  fill: "#e6e8ec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_971",
  "data-name": "Rectangle 971",
  width: 22.213,
  height: 1.201,
  transform: "translate(127.197 57.102)",
  fill: "#e6e8ec"
}));

var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_110",
    "data-name": "Group 110",
    width: 163.336,
    height: 110,
    viewBox: "0 0 163.336 110",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Devices.04097396.svg";
export { ForwardRef as ReactComponent };